import React, { forwardRef } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './css/BaseButton.css';

interface BaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    ariaLabel: string;
    tooltipText?: string;
    children: React.ReactNode;
}

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    (
        {
            ariaLabel,
            tooltipText,
            children,
            className = '',
            ...rest
        },
        ref
    ) => {

        // The actual DOM <button> — this is what Overlay and parents need access to
        const button = (
            <button
                ref={ref}
                aria-label={ariaLabel}
                className={`base-button ${className}`}
                {...rest}
            >
                {children}
            </button>
        );

        // If no tooltip, return the button directly
        if (!tooltipText) {
            return button;
        }

        // Otherwise wrap it in OverlayTrigger
        return (
            <OverlayTrigger
                placement="auto"
                delay={{ show: 300, hide: 100 }}
                trigger={['hover', 'focus']}
                overlay={
                    <Tooltip className="sb-tooltip">
                        {tooltipText}
                    </Tooltip>
                }
            >
                {/* span wrapper required because OverlayTrigger cannot attach to disabled buttons */}
                <div>
                    {button}
                </div>
            </OverlayTrigger>
        );
    }
);

export default BaseButton;
